import * as React from 'react'
import { SVGProps } from 'react'

export const NoItineraryArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="67"
        height="56"
        viewBox="0 0 67 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.92769 43.7632C19.7514 21.5679 39.5025 7.58265 64.5238 0.375818C65.922 -0.0268961 67.2165 1.3687 65.9806 2.13665C65.3668 2.51812 64.6817 2.66123 64.1108 2.82804C54.9514 5.85679 46.8058 10.9197 38.6858 15.8529C26.9713 22.9441 17.9549 32.7569 10.2619 44.0603C9.90032 44.5256 9.72022 45.0961 9.20488 46.34C15.068 43.9748 19.0955 38.8412 24.8539 37.6777C25.2268 37.6024 25.6016 37.8207 25.7758 38.1589C25.9347 38.4675 25.8318 38.8296 25.5561 39.0404C22.3689 41.4767 19.1199 43.9588 15.9886 46.4653C12.7057 49.0932 9.55227 51.748 6.21741 54.2977C3.76145 56.1517 1.84444 55.6186 1.21712 52.6515C0.35506 48.8251 0.490944 45.3467 0.707673 41.4567C0.724177 41.1605 1.50337 37.0624 1.70977 36.7C1.92427 36.1512 2.18747 35.6756 2.50192 35.2237C2.91567 34.629 3.83693 34.7544 4.26408 35.3395C4.31669 35.4116 4.37778 35.5102 4.45644 35.6628C4.92457 36.7056 4.48317 41.5771 4.92769 43.7632Z"
            fill="#D600B3"
        />
    </svg>
)
